import "./EventsAppContentTypes.scss";
import AppContentTypesList from "@/components/Common/AppContentTypesList/AppContentTypesList.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { flatten, cloneDeep } from "lodash";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "EventsAppContentTypes",
  components: { AppContentTypesList, TreeViewSelection, InfoDialog },

  data: () => ({
    dialog: false,
    headers: [
      { text: "Titel", value: "title" },
      { text: "App-ID", value: "appdinx_id" },
      { text: "App-Kanäle", value: "feature_titles" },
      { text: "Geändert", value: "change_date" },
      { text: "Aktionen", value: "actions", sortable: false }
    ],
    editedItem: {
      title: "",
      appdinx_id: null,
      mapping: []
    },
    defaultItem: {
      title: "",
      appdinx_id: null,
      mapping: []
    },
    editLoading: false
  }),
  async mounted() {
    if (!this.isAdmin) {
      return await this.$router.push(`/events/`);
    }
    await this.loadFeatureGroups();
    await this.loadAppContentTypes();
    await this.$store.dispatch("getCategoryGroupsForEvents");
  },
  computed: {
    featureGroups() {
      const featureGroups = [
        ...this.$store.state.featureGroupsForEvents
      ].filter(featureGroup =>
        featureGroup.features.some(feature => !!feature.appdinx_channel_id)
      );
      featureGroups.forEach(
        featureGroup =>
          (featureGroup.features = featureGroup.features.filter(
            feature => !!feature.appdinx_channel_id
          ))
      );
      return featureGroups;
    },
    features() {
      return flatten(
        this.featureGroups.map(featureGroup => featureGroup.features)
      );
    },
    formTitle() {
      return this.editedItem.isNew
        ? "APP-Seite anlegen"
        : "APP-Seite bearbeiten";
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return (
        this.$store.state.currentUser?.scopes.includes("role:admin") ||
        this.$store.state.currentUser?.scopes.includes("role:events_admin")
      );
    },
    total() {
      return this.appContentTypes?.length;
    },
    appContentTypes() {
      return this.$store.state.eventsAppContentTypes;
    },
    isValid() {
      return (
        this.editedItem?.title?.length &&
        this.editedItem.mapping?.length &&
        this.editedItem.mapping?.every(
          mapping => mapping.feature_id && mapping.category_ids?.length
        ) &&
        this.editedItem.appdinx_id?.toString().length &&
        !isNaN(this.editedItem.appdinx_id)
      );
    },
    categoryGroups() {
      return this.$store.state.categoryGroupsForEvents;
    }
  },
  methods: {
    updateFeatureIds(featureIds) {
      featureIds.forEach(id => {
        if (this.editedItem.mapping.find(m => m.feature_id === id)) {
          return;
        }
        this.editedItem.mapping.push({
          feature_id: id,
          category_ids: []
        });
      });
      this.editedItem.mapping = this.editedItem.mapping.filter(m =>
        featureIds.includes(m.feature_id)
      );
    },
    async createError(error) {
      this.$store.dispatch("createError", error);
    },
    async createSuccess(successMessage) {
      this.$store.dispatch("createSuccess", successMessage);
    },
    async loadFeatureGroups() {
      try {
        await this.$store.dispatch("getFeatureGroupsForEvents", {
          principal_id: this.currentPrincipal
        });
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    async loadAppContentTypes() {
      try {
        await this.$store.dispatch("getEventsAppContentTypes", {
          principal_id: this.currentPrincipal
        });
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    createItem() {
      this.editedIndex = -1;
      this.editedItem = cloneDeep(this.defaultItem);
      this.editedItem.isNew = true;
      this.editedItem.principal_id = this.currentPrincipal;
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.appContentTypes.indexOf(item);
      this.editedItem = cloneDeep(item);
      this.editedItem.isNew = false;
      this.dialog = true;
    },
    deleteItem(item) {
      this.$confirm(
        `Sind Sie sicher, dass Sie 
        <br>"${item.title}" löschen wollen?`,
        confirmWarningConfig
      ).then(async res => {
        if (res) {
          try {
            await this.deleteAppContentType(item);
          } catch (err) {
            this.createError(err);
            return;
          }
          this.editedIndex = this.appContentTypes.indexOf(item);
          this.editedItem = cloneDeep(item);
          this.appContentTypes.splice(this.editedIndex, 1);
          this.closeDelete();
        }
      });
    },
    async deleteAppContentType(item) {
      const title = item.title;
      const params = {
        principal_id: this.currentPrincipal
      };
      const headers = getTokenHeader(),
        res = await axios.delete(
          `${env.events_api_client_url}app_content_type/${item._id}`,
          {
            headers,
            params
          }
        );
      if (res.status === 200) {
        this.createSuccess(title + " gelöscht!");
      } else {
        this.createError({ ...res, text: item.title + " nicht gelöscht!" });
      }
    },
    afterSave(close) {
      if (this.editedIndex > -1) {
        this.appContentTypes[this.editedIndex] = cloneDeep(this.editedItem);
      } else {
        this.appContentTypes.push(this.editedItem);
      }
      this.loadAppContentTypes();
      if (close) {
        this.close();
      }
      this.createSuccess("Erfolgreich gespeichert!");
    },
    close() {
      this.dialog = false;
      this.closeDelete();
    },
    closeDelete() {
      this.$nextTick(() => {
        this.editedItem = cloneDeep(this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save(close) {
      this.loadingStatus(true);
      try {
        const success = this.editedItem.isNew
          ? await this.createAppContentType()
          : await this.updateAppContentType();
        if (success) {
          this.afterSave(close);
        }
      } catch (ex) {
        this.createError(ex);
      }
      this.loadingStatus(false);
    },
    async updateAppContentType() {
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.events_api_client_url}app_content_type`,
          this.editedItem,
          { headers }
        );
      return res.status === 200;
    },
    async createAppContentType() {
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.events_api_client_url}app_content_type`,
          this.editedItem,
          { headers }
        );
      this.editedItem.isNew = false;
      this.editedItem._id = res.data._id;
      return res.status === 200;
    },
    loadingStatus(status) {
      this.editLoading = status;
    }
  }
};
